import { render } from "./GestionInventario.vue?vue&type=template&id=6471189c&scoped=true"
import script from "./GestionInventario.vue?vue&type=script&lang=js"
export * from "./GestionInventario.vue?vue&type=script&lang=js"

import "./GestionInventario.vue?vue&type=style&index=0&id=6471189c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6471189c"]])

export default __exports__